export default "__VITE_ASSET__8ec8806a__"